import axios from 'axios'
import HTTP from './http'

export default {
    list: () => axios.get(HTTP.CITIES_LIST)
}
